// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2QFoz","empty":"ModalGraph_empty__1o5y-"};